import Header from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/Header/Header";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import CreatorFragment, {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { AddImages } from "@coworker/apprestructured/src/task-management/components/AddImages/AddImages";
import AttachFiles from "@coworker/apprestructured/src/task-management/components/AttachFiles/AttachFiles";
import AddLinks from "@coworker/apprestructured/src/task-management/components/AddLinks/AddLinks";
import Section from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/Section/Section";
import { memo, ReactNode, useCallback } from "react";
import CreatorFragmentConfig from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragmentConfig";
import { NewOrExistingFile } from "@coworker/apprestructured/src/shared/types/newOrExistingFile";
import {
  getByPath,
  setByPath,
} from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";

const settingsCreatorFragments: CreatorFragmentConfig[] = [
  {
    id: "assign-to-creator-fragment",
    props: {},
  },
  {
    id: "switch-creator-fragment",
    props: {
      field: "priority",
      label: "priorityString",
      icon: "notice-circle",
    },
  },
];

interface TaskCreatorAndEditorSheetSettingsSectionProps {
  headerTitle: string;
  creatorFragmentCommonProps: CreatorFragmentCommonProps;
  scheduleComponent: ReactNode;
  images: NewOrExistingFile[];
  onImagesChange: (newImages: NewOrExistingFile[]) => void;
  isDisabled: boolean;
  files: NewOrExistingFile[];
  onFilesChange: (newFiles: NewOrExistingFile[]) => void;
  setCreatorFragmentRef?: (
    key: string
  ) => (element: CreatorFragmentHandle | null) => void;
}

export const TaskCreatorAndEditorSheetSettingsSection = memo(
  (props: TaskCreatorAndEditorSheetSettingsSectionProps) => {
    const {
      headerTitle,
      creatorFragmentCommonProps,
      setCreatorFragmentRef,
      scheduleComponent,
      images,
      onImagesChange,
      isDisabled,
      files,
      onFilesChange,
    } = props;
    const { task, onTaskChange } = creatorFragmentCommonProps;
    const links =
      (!isLoading(task) && (getByPath(task, "links") as string[] | null)) || [];
    const handleLinksChange = useCallback(
      (newLinks: string[]) => {
        onTaskChange(setByPath("links", newLinks));
      },
      [onTaskChange]
    );
    return (
      <Section>
        <Header number="2" label={headerTitle} />
        <FixaListView id="settings">
          {settingsCreatorFragments.map((config) => {
            return (
              <CreatorFragment
                key={config.id}
                ref={setCreatorFragmentRef?.(config.id)}
                config={config}
                commonProps={creatorFragmentCommonProps}
              />
            );
          })}
          {scheduleComponent}
          <AddImages
            images={images}
            onConfirmClick={onImagesChange}
            disabled={isDisabled}
          />
          <AttachFiles
            disabled={isDisabled}
            files={files}
            onFilesChanged={onFilesChange}
          />
          <AddLinks
            disabled={isDisabled}
            links={links}
            onLinksChanged={handleLinksChange}
          />
        </FixaListView>
      </Section>
    );
  }
);
